import React from 'react';
import SEO from '../components/SEO';
import PlansSection from '../components/PlansSection';

const KompaClub = () => {
  return (
    <>
      <SEO pathname="/kompa-club" />
      <div className="pt-20">
        <PlansSection />
      </div>
    </>
  );
};

export default KompaClub;
